import { useNavigate } from 'react-router-dom'
import { useSelectedOrg } from '@/context/SelectedOrgContext'

export function GlobalPublishButton() {
  const { selectedOrg } = useSelectedOrg()
  const navigate = useNavigate()

  const canPublish = selectedOrg && ['owner', 'admin', 'member'].includes(selectedOrg.role)

  if (!canPublish) return null

  return (
    <button
      className="btn btn-primary btn-sm"
      onClick={() => navigate('/integrations/module-publishing')}
    >
      ↑ Publish Module
    </button>
  )
}

